
import { toast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export type Diagram = {
  id: string;
  name: string;
  created_at: string;
  modified_at: string | null;
  id_organization: string;
};

export type SortColumn = "name" | "created_at" | "modified_at";
export type SortDirection = "asc" | "desc";

export const fetchDiagrams = async (
  organizationId: string | undefined,
  sortColumn: SortColumn,
  sortDirection: SortDirection
) => {
  if (!organizationId) {
    return [];
  }

  try {
    const { data, error } = await (supabase as any)
      .from("diagrams")
      .select("*")
      .eq("id_organization", organizationId)
      .order(sortColumn, { ascending: sortDirection === "asc" });
    
    if (error) {
      toast({
        title: "Erro",
        description: "Não foi possível carregar os diagramas",
        variant: "destructive",
      });
      return [];
    }

    return data || [];
  } catch (error) {
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao buscar os diagramas",
      variant: "destructive",
    });
    return [];
  }
};

export const createDiagram = async (name: string, organizationId: string) => {
  try {
    const { error } = await (supabase as any)
      .from("diagrams")
      .insert({
        name: name,
        id_organization: organizationId
      });

    if (error) {
      toast({
        title: "Erro",
        description: "Não foi possível criar o diagrama",
        variant: "destructive",
      });
      return false;
    }

    toast({
      title: "Sucesso",
      description: "Diagrama criado com sucesso",
    });
    return true;
  } catch (error) {
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao criar o diagrama",
      variant: "destructive",
    });
    return false;
  }
};

export const updateDiagram = async (diagramId: string, name: string) => {
  try {
    const { error } = await (supabase as any)
      .from("diagrams")
      .update({ 
        name: name,
        modified_at: new Date().toISOString()
      })
      .eq("id", diagramId);

    if (error) {
      toast({
        title: "Erro",
        description: "Não foi possível atualizar o diagrama",
        variant: "destructive",
      });
      return false;
    }

    toast({
      title: "Sucesso",
      description: "Diagrama atualizado com sucesso",
    });
    return true;
  } catch (error) {
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao atualizar o diagrama",
      variant: "destructive",
    });
    return false;
  }
};

export const deleteDiagram = async (diagramId: string) => {
  try {
    const { error } = await (supabase as any)
      .from("diagrams")
      .delete()
      .eq("id", diagramId);

    if (error) {
      toast({
        title: "Erro",
        description: "Não foi possível excluir o diagrama",
        variant: "destructive",
      });
      return false;
    }

    toast({
      title: "Sucesso",
      description: "Diagrama excluído com sucesso",
    });
    return true;
  } catch (error) {
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao excluir o diagrama",
      variant: "destructive",
    });
    return false;
  }
};
